import  { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { checkUserStatusAndRedirect } from 'src/services/commonLogout';
const RouteChangeHandler = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('Page changed to:', location.pathname);
    checkUserStatusAndRedirect();
  }, [location]);

  

  return null; 
};

export default RouteChangeHandler;



// WEBPACK FOOTER //
// ./src/pages/director/LogoutFromSite.tsx